/*! Copyright (c) Safe As Milk. All rights reserved. */
class PriceRange extends HTMLElement {
  #boundOnNumberInput;
  #boundOnNumberChange;
  #boundOnRangeInput;
  constructor() {
    super();
    this.#boundOnNumberInput = this.#onNumberInput.bind(this);
    this.#boundOnNumberChange = this.#onNumberChange.bind(this);
    this.#boundOnRangeInput = this.#onRangeInput.bind(this);
  }
  connectedCallback() {
    this.rangeS = this.querySelectorAll('.price-range__input');
    this.numberS = this.querySelectorAll('.price-range__number');
    this.rangeS.forEach((el) => {
      el.addEventListener('input', this.#boundOnRangeInput);
    });
    this.numberS.forEach((el) => {
      el.addEventListener('input', this.#boundOnNumberInput);
      el.addEventListener('change', this.#boundOnNumberChange);
    });
  }
  disconnectedCallback() {
    this.rangeS.forEach((el) => {
      el.removeEventListener('input', this.#boundOnRangeInput);
    });
    this.numberS.forEach((el) => {
      el.removeEventListener('input', this.#boundOnNumberInput);
      el.removeEventListener('change', this.#boundOnNumberChange);
    });
  }
  #onRangeInput() {
    let slide1 = parseFloat(this.rangeS[0].value);
    let slide2 = parseFloat(this.rangeS[1].value);
    if (slide1 > slide2) {
      [slide1, slide2] = [slide2, slide1];
    }
    this.numberS[0].value = slide1;
    this.numberS[1].value = slide2;
  }
  #onNumberInput() {
    if (this.numberS[0].value !== '') {
      this.rangeS[0].value = this.numberS[0].value;
    }
    if (this.numberS[1].value !== '') {
      this.rangeS[1].value = this.numberS[1].value;
    }
  }
  #onNumberChange() {
    if (this.numberS[0].value === '' || this.numberS[1].value === '') {
      return;
    }
    const number1 = parseFloat(this.numberS[0].value);
    const number2 = parseFloat(this.numberS[1].value);
    if (number1 > number2) {
      this.numberS[0].value = number2;
      this.numberS[1].value = number1;
    }
    this.rangeS[0].value = this.numberS[0].value;
    this.rangeS[1].value = this.numberS[1].value;
  }
}

customElements.define('price-range', PriceRange);
//# sourceMappingURL=price-range.js.map
